export default (shop) => {

  const checkboxTime = document.querySelector('.form-check-input:checked');
  if (checkboxTime === null || checkboxTime === undefined) {
    return true
  }

  const selectedTimeDiff = document.querySelector('#selectedTimeDiff');
  const selectedHour = document.querySelector('#selectedHour');
  const selectedTimeMinute = document.querySelector('#selectedMinute');
  const selectedTimeDiffValue = selectedTimeDiff ? selectedTimeDiff.options[selectedTimeDiff.selectedIndex].value : null;
  const selectedHourValue = selectedHour ? selectedHour.options[selectedHour.selectedIndex].value : null;
  const selectedTimeMinuteValue = selectedTimeMinute ? selectedTimeMinute.options[selectedTimeMinute.selectedIndex].value : null;
  const selectedTimeValue = `${selectedHourValue}.${selectedTimeMinuteValue}`;
  const until = 'UNTIL';
  const before = 'BEFORE'

  if (!!shop.openToday && !shop.openToday.includes(',')) {
    const openTodayUpdated = shop.openToday.split('-').map(element => element.replace(':', '.'));

    if (selectedTimeDiffValue === before && parseFloat(openTodayUpdated[0], 10) <= parseFloat(selectedTimeValue)) {
      return true
    }
    else if (selectedTimeDiffValue === until && parseFloat(openTodayUpdated[1], 10) >= parseFloat(selectedTimeValue)) {
      return true
    } else {
      return false
    }
  }

  if (!!shop.openToday && shop.openToday.includes(',')) {
    const openTodayArray1 = shop.openToday.split(',').map(element => element.replace(/:/g, '.'));
    const openTodayArray2 = openTodayArray1.map(element => element.split('-'));

    if (selectedTimeDiffValue === before && parseFloat(openTodayArray2[1][0], 10) <= parseFloat(selectedTimeValue)) {
      return true;
    }
    else if (selectedTimeDiffValue === until && parseFloat(openTodayArray2[1][1], 10) >= parseFloat(selectedTimeValue)) {
      return true;
    }
    else {
      return false;
    }
  }
}
